module.exports = __webpack_public_path__ + "static/media/mountainViews.f69c92c4.svg";